import classNames from 'classnames';
import * as React from 'react';
import { ComponentLabel, IComponentItemProps } from './models';
import styles from './styles.module.scss';

const ComponentItem: React.FunctionComponent<IComponentItemProps> = (props) => {
  const { connectDragSource, isDragging, icon: Icon, type, size, dataTestId = 'componentItem' } = props;

  return (
    <div className={styles.ComponentItem} data-testid={dataTestId}>
      {connectDragSource(
        <div className={classNames(styles.icon, { [styles.dragging]: isDragging })} data-testid={`${dataTestId}-icon`}>
          {!isDragging && <Icon />}
        </div>,
      )}
      <div className={styles.label} data-testid={`${dataTestId}-label`}>
        <span>{ComponentLabel[type].toLowerCase()}</span>
        {!!size && <span className={styles.secondary}>{size}</span>}
      </div>
    </div>
  );
};

export default ComponentItem;
